import { freeze } from 'icepick';
import { defaultTimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/constants.tsx';
import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import {
	type FetchTimeTrackingOptionsSuccess,
	FETCH_TIME_TRACKING_OPTIONS_SUCCESS,
} from '../../../actions/time-tracking-options';

export type Action = FetchTimeTrackingOptionsSuccess;

const defaultState: TimeTrackingOptions = defaultTimeTrackingOptions;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: TimeTrackingOptions = defaultState, action: Action): TimeTrackingOptions => {
	switch (action.type) {
		case FETCH_TIME_TRACKING_OPTIONS_SUCCESS:
			return freeze(action.payload);
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
